(function () {
  'use strict';
  const configNode = document.getElementById('movelio-black-month-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const start = Date.parse('2026-09-30T22:01:00Z');
  const end = Date.parse('2026-11-30T23:00:00Z');
  const loadedAt = Date.now();
  const serverTime = Number(config.serverTime) * 1000;
  const preview = Boolean(window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role === 'unpublished' && new URLSearchParams(location.search).get('black_month_preview') === '1')));
  function now() { return serverTime + Date.now() - loadedAt; }
  function format(amount, currency) {
    const locale = document.documentElement.lang || 'en';
    if (currency === 'NOK' || currency === 'SEK') {
      return new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(amount / 100) + '\u00a0kr';
    }
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount / 100);
  }
  function currentDiscount(currency, amount) {
    if (config.country === 'DK') return null;
    if (currency === 'SEK') return 0;
    if (currency === 'EUR') return config.country === 'DE' ? 0 : null;
    if (currency === 'NOK') return 100000;
    const settings = window.Shopify && Shopify.currency;
    const rate = settings && settings.active === currency ? Number(settings.rate) : NaN;
    return Number.isFinite(rate) && rate > 0 ? Math.round(100000 * rate) : null;
  }
  function refresh() {
    const time = now();
    const active = preview || (time >= start && time < end);
    document.querySelectorAll('[data-black-month]').forEach(function (banner) {
      const bannerStart = Date.parse(banner.dataset.startsAt || '2026-09-30T22:01:00Z');
      const bannerEnd = Date.parse(banner.dataset.endsAt || '2026-11-30T23:00:00Z');
      banner.hidden = !(banner.dataset.enabled === 'true' && (preview || (time >= bannerStart && time < bannerEnd)));
    });
    document.querySelectorAll('[data-mbm-price]').forEach(function (node) {
      const currency = node.dataset.mbmCurrency;
      const amount = Number(node.dataset.mbmAmount);
      const discount = currentDiscount(currency, amount);
      const show = active && discount !== null && amount > discount;
      const regular = node.querySelector('[data-mbm-regular]');
      const campaign = node.querySelector('[data-mbm-campaign]');
      if (!regular || !campaign) return;
      const compare = Number(node.dataset.mbmCompare);
      const oldAmount = (currency === 'SEK' || (currency === 'EUR' && config.country === 'DE')) && compare > amount ? compare : amount;
      const baseText = format(oldAmount, currency);
      const oldPrice = node.querySelector('[data-mbm-old]');
      const regularPrice = regular.querySelector('strong');
      if (oldPrice && oldPrice.textContent !== baseText) oldPrice.textContent = baseText;
      if (regularPrice && currency !== 'DKK' && regularPrice.textContent !== format(amount, currency)) regularPrice.textContent = format(amount, currency);
      if (regular.hidden !== show) regular.hidden = show;
      if (campaign.hidden === show) campaign.hidden = !show;
      if (!show) return;
      const price = format(amount - discount, currency);
      const priceNode = node.querySelector('[data-mbm-new]');
      if (priceNode.textContent !== price) priceNode.textContent = price;
      const saving = node.querySelector('[data-mbm-saving]');
      const savingText = config.save.replace('__MBM_AMOUNT__', format((currency === 'SEK' || (currency === 'EUR' && config.country === 'DE')) ? Math.max(0, oldAmount - amount) : discount, currency));
      if (saving && saving.textContent !== savingText) saving.textContent = savingText;
    });
    document.querySelectorAll('[data-mbm-product-schema]').forEach(function (node) {
      const amount = Number(node.dataset.mbmAmount);
      const discount = currentDiscount(node.dataset.mbmCurrency, amount);
      const effective = active && discount !== null && amount > discount ? amount - discount : amount;
      const data = JSON.parse(node.textContent);
      const offers = Array.isArray(data.offers) ? data.offers : [data.offers];
      offers.filter(Boolean).forEach(offer => { offer.price = (effective / 100).toFixed(2); });
      const output = JSON.stringify(data);
      if (node.textContent !== output) node.textContent = output;
    });
    document.querySelectorAll('[data-mbm-daily]').forEach(function (node) {
      const amount = Number(node.dataset.mbmAmount);
      const discount = currentDiscount(node.dataset.mbmCurrency, amount);
      const days = Number(node.dataset.mbmDays);
      const effective = active && discount !== null && amount > discount ? amount - discount : amount;
      const text = format(effective / days, node.dataset.mbmCurrency);
      if (node.textContent !== text) node.textContent = text;
    });
  }
  function setup() {
    refresh();
    let queued = false;
    new MutationObserver(function (records) {
      if (!records.some(function (r) { return Array.from(r.addedNodes).some(function (n) { return n.nodeType === 1 && (n.matches('[data-mbm-price],[data-mbm-daily]') || n.querySelector('[data-mbm-price],[data-mbm-daily]')); }); })) return;
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; refresh(); });
    }).observe(document.body, { childList: true, subtree: true });
    setInterval(refresh, 1000);
    document.addEventListener('visibilitychange', refresh);
    document.addEventListener('shopify:section:load', refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();

